import { connect } from 'react-redux'
import {
  isOwnerOnboardingActive,
  isOnboardingOnInviteStep,
} from 'screens/OnboardingPopover/utils'

export default connect(state => {
  return {
    highlighted: isOwnerOnboardingActive(state),
    showPlaceholder: isOnboardingOnInviteStep(state),
  }
})
